import { css } from '@emotion/css';
import { baseTheme } from '@toeverything/theme';

export const relationContainerStyle = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '4px',
  width: '100%',
  minHeight: '24px',
  padding: '2px 0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  color: 'var(--affine-text-primary-color)',
  fontWeight: '400',
  backgroundColor: 'transparent',
});

export const relationChipStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '0 8px',
  height: '20px',
  borderRadius: '10px',
  backgroundColor: 'var(--affine-hover-color)',
  color: 'var(--affine-text-primary-color)',
  fontSize: '12px',
  lineHeight: '20px',
  whiteSpace: 'nowrap',
  maxWidth: '160px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const relationChipMissingStyle = css({
  backgroundColor: 'var(--affine-tag-red)',
  color: 'var(--affine-text-secondary-color)',
});

export const relationAddButtonStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  borderRadius: '10px',
  cursor: 'pointer',
  color: 'var(--affine-icon-color)',
  ':hover': {
    backgroundColor: 'var(--affine-hover-color)',
  },
});
